import React from 'react';
import { LinkedinIcon, UserIcon } from 'lucide-react';
import { SectionHeading } from '../product/SectionHeading';
import type { Leader } from '../../types/company';
export function LeadershipGrid({
  leaders
}: {
  leaders: Leader[];
}) {
  return <section className="w-full bg-canvas-warm py-20" aria-labelledby="leadership-heading" data-id="element-321" data-mp="12bjd6rvs3pr">
      <div className="mx-auto max-w-shell px-6" data-id="element-322" data-mp="52lzhc9e0aic">
        <SectionHeading id="leadership-heading" title="Leadership" subtitle="A Kigali-based team with backgrounds in banking, technology, and running small businesses." align="left" data-id="element-323" data-mp="3na1qfl88fh13" />
        <ul className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5" data-id="element-324" data-mp="3eaewfkhu1di2">
          {leaders.map(leader => <li key={leader.title} className="flex flex-col rounded-[14px] bg-white p-4" data-id="element-325" data-mp="3iaysekqo6b2m">
              <div role="img" aria-label="Photo placeholder" className="flex aspect-[4/5] w-full items-center justify-center rounded-[10px] bg-canvas-line/70 text-ink-muted" data-id="element-326" data-mp="1ci8lxxsn6m5g">
                <UserIcon className="h-10 w-10" strokeWidth={1.4} aria-hidden="true" data-id="element-327" data-mp="1ci16b1o589g" />
              </div>
              <div className="mt-4 flex items-start justify-between gap-2" data-id="element-328" data-mp="g14n4vlswy9n">
                <div className="min-w-0" data-id="element-329" data-mp="g38r1djp9x9x">
                  <h3 className="text-[16px] font-semibold text-ink" data-id="element-330" data-mp="b21i3b5tms1o">{leader.name}</h3>
                  <p className="mt-0.5 text-[13.5px] leading-[1.4] text-ink-muted" data-id="element-331" data-mp="3jhl881b73uci">{leader.title}</p>
                </div>
                <a href={leader.linkedin} aria-label={`${leader.title} on LinkedIn`} className="flex h-9 w-9 shrink-0 items-center justify-center rounded-[8px] border border-canvas-line text-ink-muted transition-colors duration-150 ease-out hover:border-ink/25 hover:text-brand" data-id="element-332" data-mp="3ek34qqfy67bw">
                  <LinkedinIcon className="h-4 w-4" aria-hidden="true" data-id="element-333" data-mp="13qz0dea18ouf" />
                </a>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}